const Regenerate = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 1.5C10.5 1.5 11.1369 1.59099 13.773 4.22703C16.409 6.86307 16.409 11.1369 13.773 13.773C12.839 14.7069 11.6995 15.31 10.5 15.5821M10.5 1.5L15 1.5M10.5 1.5L10.5 6M7.5 16.4999C7.5 16.4999 6.86307 16.4089 4.22703 13.7728C1.59099 11.1368 1.59099 6.86292 4.22703 4.22688C5.16099 3.29293 6.30054 2.68987 7.5 2.41772M7.5 16.4999L3 16.5M7.5 16.4999L7.5 12"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Regenerate;
